import { Stack, Tab, Tabs } from '@mui/material'
import React from 'react'
import Label from '../../../../common/components/Label'
import SenderDetails from './SenderDetails'
import { COLOR_MAP } from '../../../../constants/ColorNames'
import CampaignDetailsTab from './CampaignDetailsTab'

const OutreachDetails = () => {

  return (
    <Stack
      padding='1.6rem'
      rowGap='1rem'
      borderBottom={`0.1rem solid ${COLOR_MAP.BORDER_GREY}`}
      >
      <Stack rowGap={'1rem'}>
        <Label
          colorType="dark"
          label="Outreach Type"
        />
        <CampaignDetailsTab/>
        <SenderDetails />
      </Stack>
    </Stack>
  )
}

export default OutreachDetails